<div class="hero">
  <div class="hero-overlay">
  </div>
  <div class="hero-content d-flex">
    <div class="container d-flex flex-row">
      <div class="hero-content-text align-self-center">
        <h1>
          <span class="fw-light">Lost and found</span><br>
        </h1>
      </div>
    </div>
  </div>
</div>

<div class="container mt-4">

  <div class="row mb-3">
    <div class="col-12">
      <p>
        At {{ brandName }} we appreciate the distress you feel if your pet goes missing. Our 25 years experience in bringing lost pets home enables us to provide the best advice to help you at such a stressful time.
      </p>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col-12 col-lg-6 mb-3 accordion-wrapper">

      <div ngbAccordion [closeOthers]="true">
        <div
          ngbAccordionItem
          id="panel-1">
          <div ngbAccordionHeader>
            <button ngbAccordionButton>I've found a stray pet</button>
          </div>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <p>
                  If you've found a stray pet, there are a few things you need to know about your legal obligations. We recommend you take the following steps for dogs and cats.
                </p>
                <p>
                  <strong>If you’ve found a dog:</strong>
                </p>
                <ul>
                  <li class="mb-2">
                    Check if the dog has a collar and ID tag, if it does try contacting the keeper.
                  </li>
                  <li class="mb-2">
                    If the dog does not have an ID tag you must contact the local authority dog warden immediately and arrange for them to collect the dog.
                  </li>
                </ul>
                <p>
                  Please note: Rescue centres are unable to take in stray dogs from members of the public.
                </p>
                <p>
                  It is a legal requirement that you contact the local authorities and advise them if you find a stray dog. This ensures that the dog can be thoroughly scanned to check if a microchip is present and gives worried keepers the best possible chance of being reunited with their pet.
                </p>
                <p>
                  <strong>If you’ve found a cat:</strong>
                </p>
                <ul>
                  <li class="mb-2">
                    Ask your neigbours whether there is a cat missing; often cats believed to be strays do, in fact, belong to someone local.
                  </li>
                  <li class="mb-2">
                    Call your local Cats Protection or RSPCA to report the cat and make a request for someone to come and collect it.
                  </li>
                  <li class="mb-2">
                    If the cat is injured, they will ask you to take it to the nearest vet.
                  </li>
                </ul>
              </ng-template>
            </div>
          </div>
        </div>

        <div
          ngbAccordionItem
          id="panel-2">
          <div ngbAccordionHeader>
            <button ngbAccordionButton>I've lost my pet</button>
          </div>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <p>
                  If your pet is missing, we recommend you take the following steps:
                </p>
                <ul>
                  <li class="mb-2">
                    Check with your neighbours to make sure your pet is not with them or hiding somewhere, pay particular attention to sheds and garages where your pet may have been accidently trapped.
                  </li>
                  <li class="mb-2">
                    If you have lost your dog whilst out walking, trace the route of your "normal" walk.
                  </li>
                  <li class="mb-2">
                    <span *ngIf="!isAuthenticated">
                      Log in to your <a href="" routerLink="/login"><strong>identi account</strong></a> or call
                      identi on {{ companyPhoneNumber }} to report your pet as missing.
                    </span>
                    <span *ngIf="isAuthenticated && !(userService.isUserStoredInServicePremium() ||
                     userService.isUserStoredInServiceBasicPlus())">
                      Call identi on {{ companyPhoneNumber }} to report your pet as missing.
                    </span>
                    <span *ngIf="isAuthenticated && (userService.isUserStoredInServicePremium() ||
                     userService.isUserStoredInServiceBasicPlus())">
                      As a Premium member, you have access to our 24/7 helpline, which you can call on {{ companyMemberPhoneNumber }}.
                    </span>
                  </li>
                  <li class="mb-2">
                    Try not to panic, we have reunited thousands of missing pets with their worried keepers thanks to their microchip.
                  </li>
                  <li class="mb-2">
                    Finally, please remember to let us know when your pet comes home so that we can ensure the records on {{ brandName }} are accurate and up to date.
                  </li>
                </ul>
              </ng-template>
            </div>
          </div>
        </div>

      </div>

    </div>

    <div class="col-12 col-lg-6">

        <!-- TODO: Un-comment this card once we have an array of missing pets -->
        <!-- <div class="card">
          <div
            class="card-img-top"
            [ngStyle]="{'background-image': 'url(/assets/images/placeholders/paw.png)'}"
            alt="View missing pets">
          </div>
          <div class="card-body">
            <h6 class="card-title my-0">
              View missing pets
            </h6>
            <p class="card-text">
              Access our up to date list of missing pets in your selected location.
            </p>
          </div>
          <div class="card-footer">
            <a
              class="btn btn-primary w-100"
              [routerLink]="['/lost-and-found/missing-pets']">
              View
            </a>
          </div>
        </div> -->

        <div class="card">
          <div
            class="card-img-top"
            [ngStyle]="{'background-image': 'url(/assets/images/stock/cat-and-dog.jpg)'}"
            alt="Report lost pet">
          </div>
          <div class="card-body">
            <h6 class="card-title my-0">
              Report lost pet
            </h6>
            <p class="card-text">
              If your pet has gone missing, please file your report here.
            </p>
          </div>
          <div class="card-footer">
            <a
              class="lost-and-found-button"
              [routerLink]="['/my-pets']">
              {{ isAuthenticated ? 'Report lost pet' : 'Log in and report' }}
            </a>
          </div>
        </div>

    </div>

  </div>

</div>
